/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  DummyMineableWords,
  DummyMineableWordsInterface,
} from "../DummyMineableWords";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "characters",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint88",
        name: "encoded",
        type: "uint88",
      },
    ],
    name: "decodeMword",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class DummyMineableWords__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DummyMineableWords> {
    return super.deploy(overrides || {}) as Promise<DummyMineableWords>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): DummyMineableWords {
    return super.attach(address) as DummyMineableWords;
  }
  connect(signer: Signer): DummyMineableWords__factory {
    return super.connect(signer) as DummyMineableWords__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DummyMineableWordsInterface {
    return new utils.Interface(_abi) as DummyMineableWordsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DummyMineableWords {
    return new Contract(address, _abi, signerOrProvider) as DummyMineableWords;
  }
}
